<template>
  <Dropdown placement="bottom-end" @on-click="to">
    <span class="view-main-header-item view-main-header-avatar">
      <span class="view-main-header-avatar-name">{{ username }}</span>
    </span>
    <DropdownMenu slot="list">
      <DropdownItem name="info"><Icon type="md-female" /> {{ $t('menu.info') }}</DropdownItem>
      <DropdownItem name="logout"><Icon type="md-power" /> {{ $t('logout') }}</DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import app from '@/tools';

export default {
  computed: {
    username () {
      return app.user().name
    }
  },

  methods: {
    // 选择菜单
    to (key) {
      switch (key) {
        case 'info':
          return this.$router.push('/main/info')
        case 'logout':
          app.logout()
          break;
      }
    },
  }
}
</script>